
import { ref } from 'vue'
import { useTimeout } from './useTimeout.js'

export function usePool(
  fn,
  interval = 1000,
  options = {},
) {
  const { start } = useTimeout(loop, interval, { immediate: false })
  const isActive = ref(false)
  const { immediate = true, immediateCallback = false } = options

  async function loop() {
    if (!isActive.value) return
    await fn()
    start()
  }

  function pause() {
    isActive.value = false
  }

  function resume() {
    if (isActive.value) return
    isActive.value = true
    if (immediateCallback) {
      fn()
    }
    start()
  }

  if (immediate) {
    resume()
  }

  // tryOnScopeDispose(pause)

  return {
    isActive,
    pause,
    resume,
  }
}
